module.exports = __webpack_public_path__ + "static/media/0001.a4392e05.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Carousel/CarouselMedia/0001.jpg
// module id = 160
// module chunks = 0